module.exports = __webpack_public_path__ + "static/media/fumi.359ab136.png";